import { useViewport } from 'developer-docs-shared-components/hooks/useViewport';
import { MOBILE_MENU_BREAKPOINT, mediaQueries, viewportSizes } from 'developer-docs-shared-components/utils/mediaQueries';
import { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { selectSearchQuery } from '../../selectors/searchState';
import SearchInput from '../search/SearchInput';
import DropdownSearchInput from '../search/dropdownSearch/DropdownSearchInput';

/**
 * Positions the search properly.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const SearchWrapper = styled.div.withConfig({
  displayName: "Search__SearchWrapper",
  componentId: "sc-1wm0rmm-0"
})(["", "{min-width:240px;}", "{padding-top:1px;padding:16px 0;}"], mediaQueries.aboveWidth(viewportSizes.laptop), mediaQueries.belowWidth(MOBILE_MENU_BREAKPOINT));
const Search = () => {
  const location = useLocation();
  const [searchInput, setSearchInput] = useState('');
  const [dropdownSearchFocused, setDropdownSearchFocused] = useState(false);
  const {
    isMobile
  } = useViewport();
  const onSearchResultsPage = useMemo(() => location.pathname === '/search', [location]);
  const sharedProps = {
    searchInput,
    setSearchInput
  };
  return /*#__PURE__*/_jsx(SearchWrapper, {
    children: onSearchResultsPage || isMobile ? /*#__PURE__*/_jsx(SearchInput, Object.assign({}, sharedProps)) : /*#__PURE__*/_jsx(DropdownSearchInput, Object.assign({}, sharedProps, {
      dropdownSearchFocused: dropdownSearchFocused,
      setDropdownSearchFocused: setDropdownSearchFocused
    }))
  });
};
const mapStateToProps = state => ({
  query: selectSearchQuery(state)
});
export default compose(withRouter, connect(mapStateToProps))(Search);